/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HelpUrlApiService } from './services/help-url-api.service';
import { HoedanigheidpickerApiService } from './services/hoedanigheidpicker-api.service';
import { MailOnsApiService } from './services/mail-ons-api.service';
import { TestprofielApiService } from './services/testprofiel-api.service';
import { UploadApiService } from './services/upload-api.service';
import { VoorwiepickerApiService } from './services/voorwiepicker-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HelpUrlApiService,
    HoedanigheidpickerApiService,
    MailOnsApiService,
    TestprofielApiService,
    UploadApiService,
    VoorwiepickerApiService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
